import React, { createContext, useReducer } from "react";

export const ArtsContext = createContext([]);

export const ArtsContextProvider = (props) => {
    const [arts, dispatchToArts] = useReducer(
        (state, action) => {
            switch (action.type) {
                case "SET_ARTS":
                    return action.payload.arts;
                case "ADD_VOTE":
                    state.map(art => {
                        if (art.nodeId === action.payload.artId) art.votes = action.payload.votes;
                    })
                    return state;
                case "REMOVE_VOTE":
                    state.map(art => {
                        if (art.nodeId === action.payload.artId) art.votes = action.payload.votes;
                    })
                    return state;
                default:
                    throw new Error();
            }
        },
        []
    );

    return (
        <ArtsContext.Provider
            value={[arts, dispatchToArts]}
        >
            {props.children}
        </ArtsContext.Provider>
    );
};